export const setBotQueryFilters = (state, action) => {
  state.botQuery.filters[action.payload.key] = action.payload.value
}
